import { createAsyncThunk } from '@reduxjs/toolkit';

import activateUserAccount from 'services/auth/activateUserAccount';

export const activateUserAccountAction = createAsyncThunk('auth/activateUserAccount', async (userData) => {
  const { firstName, lastName, password, token } = userData;

  return activateUserAccount({ firstName, lastName, password, token });
});
